import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Question from './questions/Question';

const NpsScalePopup = (props) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    setIsInView(true);
  }, []);

  // waits till the animation is completed and then runs a callback
  const animateFirst = fn => (...args) => {
    setIsInView(false);

    setTimeout(() => {
      fn(...args);
    }, 300);
  };

  return (
    <div className={cx('c-nps-scale-popup', { 'c-nps-scale-popup--initial': !isInView })}>
      <Question
        question={props.activeQuestion}
        onClose={animateFirst(() => props.close())}
        onAnswer={props.isLastQuestion ? animateFirst(props.answerQuestion) : props.answerQuestion}
        onCloseAndSave={animateFirst(() => props.close(true))}
      />
    </div>
  );
};

NpsScalePopup.propTypes = {
  activeQuestion: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  answerQuestion: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  isLastQuestion: PropTypes.bool.isRequired,
};

export default NpsScalePopup;
